import React, { useState, useEffect, useMemo } from "react";
import {
  getHotSpotKebele,
  getHotSpotZone,
  getHotSpotWoreda,
  getHotSpotRegionalState,
} from "../Services/apiService";
import { RiListSettingsFill } from "react-icons/ri";

const StatusItem = React.memo(({ label, value, loading }) => (
  <div className="status-item">
    <span className="status-label">{label}</span>
    <span className="status-value">{loading ? "..." : value}</span>
  </div>
));

const QuickStatus = ({ alertView }) => {
  const [statusData, setStatusData] = useState({
    totalActive: 0,
    activeZones: 0,
    activeWoredas: 0,
    loading: false
  });
  
  const memoizedStatusData = useMemo(() => statusData, [
    statusData.totalActive, 
    statusData.activeZones, 
    statusData.activeWoredas,
    statusData.loading
  ]);

  useEffect(() => {
    if (alertView !== "disease-hotspot") return;

    const fetchData = async () => {
      try {
        setStatusData(prev => ({ ...prev, loading: true }));
        
        const [regionalData, zoneData, woredaData, kebeleData] = await Promise.all([
          getHotSpotRegionalState(),
          getHotSpotZone(),
          getHotSpotWoreda(),
          getHotSpotKebele(),
        ]);
        const processData = (data) => {
          const items = Array.isArray(data) ? data : [];
          return items.filter(item => item?.endemicity && item.endemicity !== "No data");
        };
        const activeRegional = processData(regionalData);
        const activeZoneList = processData(zoneData);
        const activeWoredaList = processData(woredaData);
        const activeKebeleList = processData(kebeleData);
        const total = activeZoneList.length + activeWoredaList.length;

        setStatusData({
          totalActive: total,
          activeZones: activeZoneList.length,
          activeWoredas: activeWoredaList.length,
          loading: false
        });
      } catch (error) {
        console.error("Error fetching hotspot data:", error);
        setStatusData(prev => ({ ...prev, loading: false }));
      }
    };

    fetchData();
  }, [alertView]);

  const renderStatusItems = useMemo(() => {
    if (alertView === "disease-hotspot") {
      return (
        <>
          <StatusItem 
            label="Total Active Hotspot" 
            value={memoizedStatusData.totalActive} 
            loading={memoizedStatusData.loading} 
          />
          <StatusItem 
            label="Active Zones" 
            value={memoizedStatusData.activeZones} 
            loading={memoizedStatusData.loading} 
          />
          <StatusItem 
            label="Active Woredas" 
            value={memoizedStatusData.activeWoredas} 
            loading={memoizedStatusData.loading} 
          />
        </>
      );
    }

    return (
      <>
        <StatusItem label="Critical Alerts" value="0" loading={false} />
        <StatusItem label="Active Hotspots" value="0" loading={false} />
        <div className="status-item">
          <span className="status-label">API Status</span>
          <span className="status-value success">Live</span>
        </div>
      </>
    );
  }, [alertView, memoizedStatusData]);

  return (
    <div className="status-section">
      <div className="status-header">
        <div className="status-title">
          <RiListSettingsFill className="icon" style={{ color: "#2563eb" }} />
          <span>Quick Status</span>
        </div>
      </div>
      <div className="status-items">{renderStatusItems}</div>
    </div>
  );
};

export default QuickStatus;
